
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.25.5h17.5c.703.026 1.29.273 1.758.742.469.469.716 1.055.742 1.758v7.188c-.677-.6-1.51-.912-2.5-.938V3H4.25v6.25c-.99.026-1.823.339-2.5.938V3c.026-.703.273-1.29.742-1.758C2.961.773 3.547.526 4.25.5zM6.75 13c-.026.938-.443 1.654-1.25 2.148-.833.47-1.667.47-2.5 0-.807-.494-1.224-1.21-1.25-2.148.026-.938.443-1.654 1.25-2.148.833-.47 1.667-.47 2.5 0 .807.494 1.224 1.21 1.25 2.148zM.5 19.25c.026-.703.273-1.29.742-1.758.469-.469 1.055-.716 1.758-.742h2.5c.703.026 1.29.273 1.758.742.469.469.716 1.055.742 1.758 0 .365-.117.664-.352.898-.234.235-.533.352-.898.352h-5c-.365 0-.664-.117-.898-.352C.617 19.914.5 19.615.5 19.25zm15-6.25c-.026.938-.443 1.654-1.25 2.148-.833.47-1.667.47-2.5 0-.807-.494-1.224-1.21-1.25-2.148.026-.938.443-1.654 1.25-2.148.833-.47 1.667-.47 2.5 0 .807.494 1.224 1.21 1.25 2.148zm-6.25 6.25c.026-.703.273-1.29.742-1.758.469-.469 1.055-.716 1.758-.742h2.5c.703.026 1.29.273 1.758.742.469.469.716 1.055.742 1.758 0 .365-.117.664-.352.898-.234.235-.533.352-.898.352h-5c-.365 0-.664-.117-.898-.352-.235-.234-.352-.533-.352-.898zm12.5-3.75c-.938-.026-1.654-.443-2.148-1.25-.47-.833-.47-1.667 0-2.5.494-.807 1.21-1.224 2.148-1.25.938.026 1.654.443 2.148 1.25.47.833.47 1.667 0 2.5-.494.807-1.21 1.224-2.148 1.25zm-1.25 1.25H23c.703.026 1.29.273 1.758.742.469.469.716 1.055.742 1.758 0 .365-.117.664-.352.898-.234.235-.533.352-.898.352h-5c-.365 0-.664-.117-.898-.352-.235-.234-.352-.533-.352-.898.026-.703.273-1.29.742-1.758.469-.469 1.055-.716 1.758-.742z","fill":"#007CF0"}})])
          )
        }
      }
    